import ReactDOM from 'react-dom';
import { useEffect, useRef } from 'react';
import noScroll from 'no-scroll';
import {
  Content,
  LeftArrow,
  ModalBackdrop,
  ModalWrapper,
  RightArrow
} from './styled';
import { ModalProps } from './types';
import { ModalFooter } from './ModalFooter';
import { PageHeader } from '../PageHeader';
import { BackButtonIconEnum } from '../PageHeader/types';
import { DirectionEnum } from '../../NewSection/types';

export const Modal = ({
  isOpen,
  onClose,
  children,
  modalId,
  cypress,
  title,
  resetText,
  onReset,
  resetIsDisabled,
  confirmText,
  onConfirm,
  showHeaderBorder = true,
  footerStyles,
  modalStyles,
  closeButtonAlign = 'left',
  setMediaStyles = true,
  headerStyles,
  header,
  titleId,
  titleIcon,
  height,
  headerIcon = BackButtonIconEnum.Back,
  headerRightBlock,
  headerBottomBlock,
  headerTag,
  isHeaderHidden = false,
  withAnimation = true,
  headerLeftBlock,
  modalBackdropStyles,
  lockScroll = true,
  lockScrollContent = true,
  alwaysRender = false,
  container,
  showArrows = false,
  scrollHandler
}: ModalProps) => {
  const isMouseDownOnBackdrop = useRef(false);

  useEffect(() => {
    if (isOpen) {
      if (lockScroll) noScroll.on();
      return () => {
        if (lockScroll) {
          noScroll.off();
        }
      };
    }
  }, [isOpen]);

  if (!isOpen && !alwaysRender) return null;

  return ReactDOM.createPortal(
    <ModalBackdrop
      data-cy={cypress}
      onMouseDown={e => {
        isMouseDownOnBackdrop.current = e.target === e.currentTarget;
      }}
      onClick={() => {
        if (isMouseDownOnBackdrop.current) {
          onClose?.();
        }
        isMouseDownOnBackdrop.current = false;
      }}
      id={modalId}
      $styles={modalBackdropStyles}
      $isVisible={isOpen}
    >
      {showArrows && scrollHandler && (
        <LeftArrow onClick={() => scrollHandler(DirectionEnum.left)} />
      )}
      <ModalWrapper
        onClick={e => e.stopPropagation()}
        $styles={modalStyles}
        $mediaStyles={setMediaStyles}
        $withAnimation={withAnimation}
      >
        {header}
        {title && !isHeaderHidden && (
          <PageHeader
            id={titleId}
            height={height}
            titleIcon={titleIcon}
            icon={headerIcon}
            onClick={onClose}
            titleCypress={`${cypress}--title`}
            title={title}
            backButtonCypress={`${cypress}--header-btn-close`}
            rightBlock={headerRightBlock}
            bottomBlock={headerBottomBlock}
            closeButtonAlign={closeButtonAlign}
            showHeaderBorder={showHeaderBorder}
            headerTag={headerTag}
            styles={headerStyles}
            leftBlock={headerLeftBlock}
          />
        )}
        <Content $lockScrollContent={lockScrollContent}>{children}</Content>

        {resetText && confirmText && onConfirm && onReset && (
          <ModalFooter
            resetText={resetText}
            onReset={onReset}
            confirmText={confirmText}
            onConfirm={onConfirm}
            resetIsDisabled={!!resetIsDisabled}
            resetCypress={`${cypress}--reset-btn`}
            confirmCypress={`${cypress}--submit-button`}
            styles={footerStyles}
          />
        )}
      </ModalWrapper>
      {showArrows && scrollHandler && (
        <RightArrow onClick={() => scrollHandler(DirectionEnum.right)} />
      )}
    </ModalBackdrop>,
    container ?? document.body
  );
};
